const HIGHLIGHTS = ["塌房翻旧账", "恋情时间线", "选秀考古", "合约纠纷", "饭圈名场面", "翻红史", "综艺切片", "豪门家族瓜"];

export default function Hero() {
  return (
    <section id="top" className="paper-grain w-full overflow-hidden">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-10 px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_1fr] lg:items-center">
          {/* 左侧主文案 */}
          <div className="space-y-6">
            <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-time-line" />
              吃瓜八卦历史 · 陈年旧料 · 时间线整理
            </p>
            <h1 className="font-heading text-4xl font-black leading-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
              把那些被遗忘的<span className="text-accent-600">八卦瞬间</span>，
              <br className="hidden md:block" />
              一块块重新挖出来。
            </h1>
            <p className="max-w-2xl text-base leading-relaxed text-foreground-700">
              吃瓜考古社专注吃瓜八卦考古与旧料翻旧账。我们像整理档案一样，把散落在不同年份的
              <strong className="font-semibold text-foreground-900">陈年往事</strong>抽丝剥茧，
              拼成一条条清晰的<strong className="font-semibold text-foreground-900">吃瓜八卦时间线</strong>。
              老瓜新吃，别有风味。
            </p>
            <div className="flex flex-col gap-3 pt-2 sm:flex-row">
              <a
                href="#timeline"
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                开始考古时间线
              </a>
              <a
                href="#archive"
                className="whitespace-nowrap rounded-md border border-foreground-900/15 bg-background-50 px-6 py-3 text-center text-sm font-semibold text-foreground-900 transition-colors hover:border-accent-500 hover:text-accent-600"
              >
                浏览分类档案
              </a>
            </div>
          </div>

          {/* 右侧报头卡片 */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg border border-background-300/70 bg-background-50 p-5 shadow-none">
              <div className="absolute right-4 top-4 h-16 w-16 rotate-6 rounded-sm border border-accent-300/70 bg-accent-50/60 p-1.5">
                <div className="flex h-full w-full flex-col items-center justify-center rounded-sm border border-dashed border-accent-400 text-accent-600">
                  <span className="font-display text-lg leading-none">新瓜</span>
                </div>
              </div>
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-secondary-600">本期特别策划</p>
              <h2 className="mt-3 max-w-[16rem] font-heading text-2xl font-bold leading-snug text-foreground-950">
                “翻旧账”的正确打开方式
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                与其在热搜里吵得面红耳赤，不如回到五年前，把那段被模糊的
                <strong className="font-semibold text-foreground-900">吃瓜八卦陈年往事</strong>
                按时间轴重新读一遍。
              </p>
              <div className="mt-5 space-y-2.5 border-t border-background-200 pt-4">
                {[
                  { k: "旧料档案", v: "579 篇" },
                  { k: "时间线", v: "163 条" },
                  { k: "本周热推", v: "4 则" },
                ].map((s) => (
                  <div key={s.k} className="flex items-center justify-between text-sm">
                    <span className="text-foreground-600">{s.k}</span>
                    <span className="font-semibold text-accent-600">{s.v}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 热词走马灯 */}
        <div className="flex flex-wrap items-center gap-2 pt-1">
          <span className="mr-1 text-xs font-semibold text-foreground-500">大家正在考古：</span>
          {HIGHLIGHTS.map((h) => (
            <a
              key={h}
              href="#archive"
              className="whitespace-nowrap rounded-full bg-background-200/70 px-3 py-1 text-xs font-medium text-foreground-700 transition-colors hover:bg-accent-500 hover:text-background-50"
            >
              #{h}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}